module.exports = __webpack_public_path__ + "static/media/fo.76d76579.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/fo.svg
// module id = 649
// module chunks = 0